import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getSameCaseInfo 获取相似案件的 id 分组信息
 * @param {String} param 格式化后的查询条件
 * @param {Number} page 页码
 * @returns {Object} ids 分组 id mark 标记
 */
const getSameCaseInfo = (param, page = 1) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/similarityUcases?${param}&page=${page}`
    )
    .then(checkResponse)
}

/**
 * @function getSameCaseList 获取相似案件的列表
 * @param {String}  query 格式化后的ids
 * @returns {Object} list
 */
const getSameCaseList = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases?page=1&datetimeFormat=datetime&${query}&per=20`
    )
    .then(checkResponse)
}

/**
 * @function getDistanceConfig 获取间距配置
 * @returns {String} config[0].configs.columns[0].distance
 */
const getDistanceConfig = () => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/configs?slug=similarity-ucase-basic`
    )
    .then(checkResponse)
}

/**
 * @function createSameDownload 创建相似案件的下载
 * @param {String} param 格式化后的查询条件
 * @returns {String} id
 */
const createSameDownload = (param) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/similarity/ucases?${param}`)
    .then(checkResponse)
}

/**
 * @function getSameCaseDetailData 获取相似案件详情
 * @param {String} id 案件 id
 * @returns {Array} uiSpec res.uiSpec[0].items
 */
const getSameCaseDetailData = (id) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases/${id}/spec?datetime_format=datetime&view=web`
    )
    .then(checkResponse)
}

/**
 * @function exportSameCaseMap 获取相似案件地图
 * @param {String} id 案件 id
 * @returns {Array} uiSpec res.uiSpec[0].items
 */
const exportSameCaseMap = (data) => {
  return axios
    .post(
      `/api/v1/projects/${getProjectId()}/download/task/similarityMap`, data
    )
    .then(checkResponse)
}

export{
  getSameCaseInfo,
  getSameCaseList,
  getSameCaseDetailData,
  getDistanceConfig,
  createSameDownload,
  exportSameCaseMap
}
